// Tanggal kalender yang DIPILIH user (zona waktu browser) sebagai "YYYY-MM-DD".
// Jangan pakai toISOString(): itu UTC, jadi tanggal yang dipilih sebelum 07:00 WIB
// tersimpan mundur sehari (bisa pindah tahun di 1 Januari).
export function tanggalLokal(d) {
  const t = d instanceof Date ? d : new Date(d);
  const mm = String(t.getMonth() + 1).padStart(2, "0");
  const dd = String(t.getDate()).padStart(2, "0");
  return `${t.getFullYear()}-${mm}-${dd}`;
}
